/* Digital Suite — Theme JS (vanilla, no dependencies) */
(function () {
  'use strict';

  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const formatMoney = (cents) => {
    const v = (cents / 100).toLocaleString(window.Shopify?.locale || 'en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const code = window.Shopify?.currency?.active || 'INR';
    const symbols = { INR: '₹', USD: '$', EUR: '€', GBP: '£', AED: 'د.إ' };
    return (symbols[code] || code + ' ') + v;
  };

  /* ---------- Header scroll state ---------- */
  const header = $('.site-header');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Drawer (generic) ---------- */
  function openDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    drawer.setAttribute('aria-hidden', 'false');
    const focusable = drawer.querySelector('[autofocus], input, button, [href]');
    if (focusable) setTimeout(() => focusable.focus(), 100);
  }
  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    drawer.setAttribute('aria-hidden', 'true');
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer($('#' + opener.dataset.drawerOpen));
    }
    if (e.target.matches('.drawer__overlay, [data-drawer-close]')) {
      const d = e.target.closest('.drawer');
      closeDrawer(d);
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') $$('.drawer.is-open').forEach(closeDrawer);
  });

  /* ---------- Hero slider ---------- */
  $$('[data-hero-slider]').forEach(initSlider);
  function initSlider(slider) {
    const slides = $$('[data-hero-slide]', slider);
    const dots = $$('[data-hero-dot]', slider);
    if (slides.length <= 1) return;
    let idx = 0;
    const show = (i) => {
      slides.forEach((s, n) => s.style.display = n === i ? '' : 'none');
      dots.forEach((d, n) => d.setAttribute('aria-current', n === i ? 'true' : 'false'));
      idx = i;
    };
    show(0);
    dots.forEach((d, n) => d.addEventListener('click', () => show(n)));
    let timer = setInterval(() => show((idx + 1) % slides.length), 6000);
    slider.addEventListener('mouseenter', () => clearInterval(timer));
    slider.addEventListener('mouseleave', () => timer = setInterval(() => show((idx + 1) % slides.length), 6000));
  }

  /* ---------- Reveal animations ---------- */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
    }, { threshold: .12, rootMargin: '0px 0px -40px 0px' });
    $$('.reveal').forEach(el => io.observe(el));
  }

  /* ---------- Back to top ---------- */
  const btt = $('[data-back-to-top]');
  if (btt) {
    btt.hidden = false;
    const tog = () => btt.classList.toggle('is-visible', window.scrollY > 600);
    window.addEventListener('scroll', tog, { passive: true });
    btt.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
    tog();
  }

  /* ---------- Stats counter ---------- */
  $$('[data-counter]').forEach(el => {
    const target = parseFloat(el.dataset.counter);
    const suffix = el.dataset.suffix || '';
    const dur = 1600;
    const start = performance.now();
    const tick = (t) => {
      const p = Math.min(1, (t - start) / dur);
      const eased = 1 - Math.pow(1 - p, 3);
      const val = target * eased;
      el.textContent = (val >= 1000 ? Math.round(val).toLocaleString() : val.toFixed(target % 1 ? 1 : 0)) + suffix;
      if (p < 1) requestAnimationFrame(tick);
    };
    if ('IntersectionObserver' in window) {
      const o = new IntersectionObserver(es => { if (es[0].isIntersecting) { requestAnimationFrame(tick); o.disconnect(); } });
      o.observe(el);
    } else { requestAnimationFrame(tick); }
  });

  /* ---------- Announcement bar dismiss ---------- */
  const ann = $('[data-announcement]');
  if (ann) {
    if (sessionStorage.getItem('ann-dismissed') === '1') ann.style.display = 'none';
    const close = ann.querySelector('[data-announcement-close]');
    if (close) close.addEventListener('click', () => { ann.style.display = 'none'; sessionStorage.setItem('ann-dismissed', '1'); });
  }

  /* ---------- Product gallery ---------- */
  $$('[data-product-gallery]').forEach(g => {
    const main = g.querySelector('[data-product-main-image]');
    const thumbs = $$('[data-product-thumb]', g);
    thumbs.forEach(t => t.addEventListener('click', () => {
      const url = t.dataset.imageUrl;
      const alt = t.dataset.imageAlt || '';
      if (main && url) { main.querySelector('img').src = url; main.querySelector('img').alt = alt; }
      thumbs.forEach(x => x.setAttribute('aria-current', 'false'));
      t.setAttribute('aria-current', 'true');
    }));
  });

  /* ---------- Product tabs ---------- */
  $$('[data-tabs]').forEach(tabs => {
    const buttons = $$('[role="tab"]', tabs);
    const panels = $$('[role="tabpanel"]', tabs);
    buttons.forEach((b, i) => b.addEventListener('click', () => {
      buttons.forEach(x => x.setAttribute('aria-selected', 'false'));
      panels.forEach(x => x.setAttribute('aria-hidden', 'true'));
      b.setAttribute('aria-selected', 'true');
      panels[i].setAttribute('aria-hidden', 'false');
    }));
  });

  /* ---------- Quantity input ---------- */
  $$('[data-qty]').forEach(q => {
    const input = q.querySelector('input');
    q.querySelector('[data-qty-dec]')?.addEventListener('click', () => { input.value = Math.max(parseInt(input.min || 1, 10), parseInt(input.value, 10) - 1); input.dispatchEvent(new Event('change', { bubbles: true })); });
    q.querySelector('[data-qty-inc]')?.addEventListener('click', () => { input.value = parseInt(input.value, 10) + 1; input.dispatchEvent(new Event('change', { bubbles: true })); });
  });

  /* ---------- Variant selection ---------- */
  $$('[data-variant-form]').forEach(form => {
    const data = JSON.parse(form.dataset.variants || '[]');
    const updatePrice = (variant) => {
      if (!variant) return;
      const wrap = $('[data-product-price]');
      if (wrap) wrap.innerHTML = renderPrice(variant);
      const addBtn = $('[data-add-to-cart]');
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.querySelector('[data-add-text]').textContent = variant.available ? (form.dataset.addLabel || 'Add to cart') : (form.dataset.soldOutLabel || 'Sold out');
      }
      const idInput = form.querySelector('[name="id"]');
      if (idInput) idInput.value = variant.id;
    };
    function renderPrice(v) {
      let html = '<span class="price' + (v.compare_at_price > v.price ? ' price--sale' : '') + '">' + formatMoney(v.price) + '</span>';
      if (v.compare_at_price && v.compare_at_price > v.price) {
        html += ' <span class="price price--compare">' + formatMoney(v.compare_at_price) + '</span>';
        const pct = Math.round((1 - v.price / v.compare_at_price) * 100);
        html += ' <span class="save">−' + pct + '%</span>';
      }
      return html;
    }
    function findVariant() {
      const sel = $$('[data-option]', form).map(i => i.value);
      return data.find(v => v.options.every((o, n) => o === sel[n]));
    }
    form.addEventListener('change', () => updatePrice(findVariant()));
    updatePrice(data[0]);
  });

  /* ---------- Cart drawer ---------- */
  const cartDrawer = $('#cart-drawer');
  async function fetchCart() {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    return res.json();
  }
  async function renderCart() {
    if (!cartDrawer) return;
    const cart = await fetchCart();
    const body = cartDrawer.querySelector('[data-cart-body]');
    const footer = cartDrawer.querySelector('[data-cart-footer]');
    const countEls = $$('[data-cart-count]');
    countEls.forEach(c => c.textContent = cart.item_count);
    countEls.forEach(c => c.style.display = cart.item_count > 0 ? '' : 'none');
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-empty"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg><h3>Your cart is empty</h3><p>Browse our digital marketing tools and courses.</p><a href="/collections/all" class="btn btn--primary">Continue shopping</a></div>';
      footer.innerHTML = '';
      return;
    }
    body.innerHTML = cart.items.map(item => `
      <div class="cart-line" data-line-key="${item.key}">
        <div class="cart-line__img"><img src="${item.image}" alt="${item.product_title}" loading="lazy"></div>
        <div>
          <div class="cart-line__title"><a href="${item.url}">${item.product_title}</a></div>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-line__variant">${item.variant_title}</div>` : ''}
          <div class="cart-line__qty">
            <button type="button" data-line-update="${item.key}" data-line-qty="${item.quantity - 1}" aria-label="Decrease">−</button>
            <span>${item.quantity}</span>
            <button type="button" data-line-update="${item.key}" data-line-qty="${item.quantity + 1}" aria-label="Increase">+</button>
          </div>
          <button type="button" class="cart-line__remove" data-line-update="${item.key}" data-line-qty="0">Remove</button>
        </div>
        <div class="cart-line__price">${formatMoney(item.final_line_price)}</div>
      </div>
    `).join('');
    footer.innerHTML = `
      <div class="cart-totals">
        <span class="cart-totals__label">Subtotal</span>
        <span class="cart-totals__value">${formatMoney(cart.total_price)}</span>
      </div>
      <p class="cart-tax-note">Taxes and shipping calculated at checkout.</p>
      <a href="/checkout" class="btn btn--primary btn--full btn--lg">Check out</a>
      <a href="/cart" class="btn btn--ghost btn--full" style="margin-top:.5rem">View cart</a>
    `;
  }
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-line-update]');
    if (!btn) return;
    e.preventDefault();
    const id = btn.dataset.lineUpdate;
    const qty = parseInt(btn.dataset.lineQty, 10);
    await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id, quantity: qty }) });
    renderCart();
  });
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const original = btn.innerHTML;
    btn.disabled = true; btn.innerHTML = '<span>Adding...</span>';
    try {
      const fd = new FormData(form);
      const res = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd });
      if (!res.ok) throw new Error('add failed');
      await renderCart();
      openDrawer(cartDrawer);
    } catch (err) {
      window.location.href = '/cart';
    } finally {
      btn.disabled = false; btn.innerHTML = original;
    }
  });
  if (cartDrawer) renderCart();

  /* ---------- Predictive search ---------- */
  const searchDrawer = $('#search-drawer');
  if (searchDrawer) {
    const input = searchDrawer.querySelector('input[type="search"]');
    const results = searchDrawer.querySelector('[data-search-results]');
    let t;
    input?.addEventListener('input', () => {
      clearTimeout(t);
      const q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      t = setTimeout(async () => {
        try {
          const r = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,article,page&resources[limit]=8`);
          const d = await r.json();
          const products = d.resources?.results?.products || [];
          const articles = d.resources?.results?.articles || [];
          if (!products.length && !articles.length) {
            results.innerHTML = `<p style="padding:1rem;color:var(--color-text-muted)">No results for "${q}"</p>`;
            return;
          }
          let html = '';
          if (products.length) {
            html += '<h4 class="footer__heading" style="color:var(--color-text-muted);margin-top:1rem">Products</h4>';
            html += products.map(p => `
              <a href="${p.url}" class="search-result">
                <div class="search-result__img"><img src="${p.image || ''}" alt="" loading="lazy"></div>
                <div><div class="search-result__title">${p.title}</div><div class="search-result__price">${p.price || ''}</div></div>
              </a>`).join('');
          }
          if (articles.length) {
            html += '<h4 class="footer__heading" style="color:var(--color-text-muted);margin-top:1rem">Articles</h4>';
            html += articles.map(a => `<a href="${a.url}" class="search-result"><div><div class="search-result__title">${a.title}</div></div></a>`).join('');
          }
          html += `<a href="/search?q=${encodeURIComponent(q)}" class="btn btn--ghost btn--full" style="margin-top:1rem">View all results</a>`;
          results.innerHTML = html;
        } catch (err) { /* noop */ }
      }, 250);
    });
  }

  /* ---------- Wishlist (localStorage, no app) ---------- */
  const WL_KEY = 'wishlist';
  const getWL = () => JSON.parse(localStorage.getItem(WL_KEY) || '[]');
  const setWL = (arr) => localStorage.setItem(WL_KEY, JSON.stringify(arr));
  const refreshWLButtons = () => {
    const wl = getWL();
    $$('[data-wishlist-toggle]').forEach(b => b.setAttribute('aria-pressed', wl.includes(b.dataset.wishlistToggle) ? 'true' : 'false'));
    $$('[data-wishlist-count]').forEach(c => c.textContent = wl.length);
  };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-wishlist-toggle]');
    if (!b) return;
    e.preventDefault();
    const id = b.dataset.wishlistToggle;
    let wl = getWL();
    wl = wl.includes(id) ? wl.filter(x => x !== id) : [...wl, id];
    setWL(wl);
    refreshWLButtons();
  });
  refreshWLButtons();

  /* ---------- Newsletter form ---------- */
  $$('form[data-newsletter]').forEach(f => {
    f.addEventListener('submit', async (e) => {
      // Let Shopify customer endpoint handle it; just show optimistic UI
      const status = f.querySelector('.form-status');
      if (status) { status.className = 'form-status form-status--success'; status.textContent = 'Thanks! Please check your inbox.'; }
    });
  });

})();
